import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userConferencesStateSelector} from './user-conferences-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {Conference} from 'src/openapi/admin/models/Conference';

export const userConferencesConferenceSlice = getCachedTableDataSlice<
    Record<string, Conference>,
    AccountSearchCriteria,
    AccountSortField,
    undefined
>('userConferencesConference');

export const userConferencesConferenceActions = userConferencesConferenceSlice.actions;

const userConferencesConferenceCacheSelector: CachedTableCacheSelector<Record<string, Conference>>
    = state => state.userPage.tabs.userConferences.conference.cache;
export const userConferencesConferenceDataSelector: CachedTableDataSelector<Record<string, Conference>>
    = state => state.userPage.tabs.userConferences.conference;
export const userConferencesConferenceResultSelector = getCachedTableResultSelector(
    userConferencesConferenceCacheSelector,
    userConferencesStateSelector,
);
